const MODELS = [
  { id: 'gpt-4o-mini', label: 'GPT-4o mini' },
  { id: 'gpt-4o', label: 'GPT-4o' },
  { id: 'gpt-5.4', label: 'GPT-5.4' },
  { id: 'gpt-5.5', label: 'GPT-5.5' },
];

import { FaMagnifyingGlass } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";

/**
 * Component superior de la barra lateral que conté el botó principal per
 * iniciar un nou xat i el botó per obrir el modal de cerca.
 * 
 * @param {Object} props - Propietats (funcions onNewChat, onSearchOpen, onClose, onToggleSidebar).
 */
export function SidebarTop({ onNewChat, onSearchOpen, onClose, onToggleSidebar }) {
  const handleClose = () => {
    if (window.innerWidth <= 768) {
      onClose?.();
    } else {
      onToggleSidebar?.();
    }
  };

  return (
    <div className="sidebar-top">
      <button id="onb-new-chat" className="new-chat-btn" onClick={onNewChat}>+ Nou xat</button>
      <div className="sidebar-top-buttons">
        <button className="sidebar-top-action-btn" onClick={onSearchOpen} title="Filtrar xats">
          <FaMagnifyingGlass size={15} />
        </button>
        <button className="sidebar-top-action-btn" onClick={handleClose} title="Tancar barra lateral">
          <IoClose size={18} />
        </button>
      </div>
    </div>
  );
}
